(function () {

  function fixProperties() {
    document.querySelectorAll('.cart-items__property').forEach(function (prop) {
      var dt = prop.querySelector('dt');
      var dd = prop.querySelector('dd');
      if (!dt || !dd) return;

      var key = dt.textContent.trim().replace(/:$/, '');

      // upload_1, upload_2, itd.
      if (/^upload_\d+$/.test(key)) {
        var link = dd.querySelector('a');
        if (!link) return;

        var num = key.replace('upload_', '');
        var label = num === '1' ? 'Plik' : 'Plik ' + num;

        dt.textContent = label + ':';
        link.textContent = 'Podgląd';
        link.title = 'Otwórz plik w nowej karcie';

        prop.setAttribute('data-fixed', '1');
      }
    });
  }

  // Odpala co 100ms przez max 5 sekund, potem odpuszcza
  var attempts = 0;
  var interval = setInterval(function () {
    fixProperties();
    attempts++;
    if (attempts >= 50) clearInterval(interval);
  }, 100);

  // MutationObserver jako backup dla późniejszych zmian (np. odświeżenie koszyka AJAX)
  var observer = new MutationObserver(fixProperties);
  observer.observe(document.body, { childList: true, subtree: true });

})();